// 共享常量定义

// 知识库难度级别
export const DIFFICULTY_LEVELS = {
  BEGINNER: 'beginner',
  INTERMEDIATE: 'intermediate',
  ADVANCED: 'advanced',
} as const;

// 知识点难度
export const KNOWLEDGE_POINT_DIFFICULTIES = {
  EASY: 'easy',
  MEDIUM: 'medium',
  HARD: 'hard',
} as const;

// 知识点重要性级别
export const IMPORTANCE_LEVELS = {
  VERY_LOW: 1,
  LOW: 2,
  MEDIUM: 3,
  HIGH: 4,
  VERY_HIGH: 5,
} as const;

// 文档状态
export const DOCUMENT_STATUSES = {
  UPLOADED: 'uploaded',
  PROCESSING: 'processing',
  PROCESSED: 'processed',
  ERROR: 'error',
} as const;

// 知识点状态
export const KNOWLEDGE_POINT_STATUSES = {
  ACTIVE: 'active',
  REVIEW: 'review',
  ARCHIVED: 'archived',
} as const;

// 知识库状态
export const KNOWLEDGE_BASE_STATUSES = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  DRAFT: 'draft',
} as const;

// 知识点关系类型
export const RELATION_TYPES = {
  PREREQUISITE: 'prerequisite',
  RELATED: 'related',
  DEPENDS_ON: 'depends_on',
  SIMILAR: 'similar',
} as const;

// 文件类型
export const SUPPORTED_FILE_TYPES = {
  PDF: 'pdf',
  DOCX: 'docx',
  TXT: 'txt',
  MD: 'md',
} as const;

// 题目类型
export const QUESTION_TYPES = {
  MULTIPLE_CHOICE: 'multiple_choice',
  TRUE_FALSE: 'true_false',
  FILL_BLANK: 'fill_blank',
} as const;

// 默认分页设置
export const DEFAULT_PAGINATION = {
  PAGE: 1,
  LIMIT: 20,
  MAX_LIMIT: 100,
} as const;

// 文件大小限制（字节）
export const FILE_SIZE_LIMITS = {
  MAX_UPLOAD_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_PDF_SIZE: 50 * 1024 * 1024,    // 50MB
  MAX_TEXT_SIZE: 1 * 1024 * 1024,    // 1MB
} as const;

// AI模型配置
export const AI_MODELS = {
  TEXT_GENERATION: '@cf/meta/llama-2-7b-chat-int8',
  EMBEDDING: '@cf/baai/bge-base-en-v1.5',
  TEXT_CLASSIFICATION: '@cf/microsoft/DialoGPT-medium',
} as const;

// 向量维度
export const VECTOR_DIMENSIONS = {
  DEFAULT: 768,
  LARGE: 1024,
  SMALL: 384,
} as const;

// 缓存时间（秒）
export const CACHE_DURATIONS = {
  SHORT: 300,    // 5分钟
  MEDIUM: 3600,  // 1小时
  LONG: 86400,   // 1天
} as const;

// 错误消息
export const ERROR_MESSAGES = {
  INVALID_REQUEST: '无效的请求参数',
  NOT_FOUND: '请求的资源不存在',
  UNAUTHORIZED: '未授权访问',
  FORBIDDEN: '禁止访问',
  INTERNAL_ERROR: '服务器内部错误',
  SERVICE_UNAVAILABLE: '服务暂时不可用',
  FILE_TOO_LARGE: '文件大小超出限制',
  UNSUPPORTED_FILE_TYPE: '不支持的文件类型',
  DUPLICATE_CONTENT: '检测到重复内容',
  AI_PROCESSING_ERROR: 'AI处理失败',
} as const;

// 成功消息
export const SUCCESS_MESSAGES = {
  CREATED: '创建成功',
  UPDATED: '更新成功',
  DELETED: '删除成功',
  UPLOADED: '上传成功',
  PROCESSED: '处理完成',
} as const;
